import script from "./ScrollControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollControl.vue?vue&type=script&setup=true&lang=js"

import "./ScrollControl.vue?vue&type=style&index=0&id=66684f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66684f62"]])

export default __exports__